

import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const UserIconMobileSelected = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 28 28">
      <path d="M23.3891 17.5621C24.4205 18.5623 25 19.9188 25 21.3333V23.5C25 24.3284 24.3284 25 23.5 25H4.5C3.67157 25 3 24.3284 3 23.5V21.3333C3 19.9188 3.57946 18.5623 4.61091 17.5621C5.64236 16.5619 7.04131 16 8.5 16H19.5C20.9587 16 22.3576 16.5619 23.3891 17.5621Z" fill="#C72037"/>
      <path d="M14 3C11.2386 3 9 5.23858 9 8C9 10.7614 11.2386 13 14 13C16.7614 13 19 10.7614 19 8C19 5.23858 16.7614 3 14 3Z" fill="#C72037"/>
    </SvgIcon>
  );
}

export default UserIconMobileSelected;